/** Human page names surfaced in the access-denied toast (ADR-0014). Orders keeps its
 *  feature-local `ORDERS_PAGE_NAME`; Product Management spans four product features with no
 *  umbrella feature, so its name lives here in the neutral config layer. */
export const PRODUCT_MANAGEMENT_PAGE_NAME = 'Product Management';

/** The Dealer portal (ADO 120818 §G), refused to every internal role. It spans the dealer modules'
 *  own features, so like Product Management it has no single feature to live in. */
export const DEALER_PORTAL_PAGE_NAME = 'Dealer Portal';
